import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'agent-registry',
});

export const agentDetailRouteRef = createSubRouteRef({
  id: 'agent-registry/detail',
  parent: rootRouteRef,
  path: '/:name',
});
